import { UtilitarioService } from "@app/services/utilitario.service";

export class Filtros {

    ParticipanteId: number;
    DataInicial: string;
    DataFinal: string;
    UnidadeId: number;
    Observacao: string;

    constructor() {
        this.DataInicial = UtilitarioService.retornaDataAtualMaisDias(0);
        this.DataFinal = UtilitarioService.retornaDataAtualMaisDias(0);
    }

}